"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _DiagnosticFitItem = _interopRequireDefault(require("@jobmatchme/ui/es/components/DiagnosticFitItem"));

var _DiagnosticFitEmpty = _interopRequireDefault(require("@jobmatchme/ui/es/components/DiagnosticFitItem/DiagnosticFitEmpty"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var Diagnostic = function Diagnostic(_ref) {
  var diagnostic = _ref.diagnostic,
      t = _ref.t;
  var translateNs = 'pc-matching:PcProfile';
  var bcEmpty = diagnostic.itemsFit.filter(function (d) {
    return d.itemMissingInJoboffer;
  }).length === diagnostic.itemsFit.length;
  var pcEmpty = diagnostic.itemsFit.filter(function (d) {
    return d.itemMissingInProfile;
  }).length === diagnostic.itemsFit.length;

  var isGkAnswersEmpty = function isGkAnswersEmpty() {
    var fitNumbers = diagnostic.itemsFit.length;
    var emptyAnswerCounter = 0;
    diagnostic.itemsFit.forEach(function (d) {
      if (d.itemMissingInJoboffer) emptyAnswerCounter++;
    });
    return emptyAnswerCounter === fitNumbers ? true : false;
  };

  var DiagnosticList = function DiagnosticList() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
      item: true,
      xs: 12,
      className: _styleModule.default.diagnosticList,
      children: diagnostic.itemsFit.map(function (d) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DiagnosticFitItem.default, {
          t: t,
          name: d.name,
          fit: d.fit * 100 || 0,
          namespace: translateNs,
          pcValue: d.pcValue || 0,
          bcValue: d.bcValue || 0,
          itemMissingInProfile: d.itemMissingInProfile,
          itemMissingInJoboffer: d.itemMissingInJoboffer,
          empty: bcEmpty || pcEmpty || bcEmpty && pcEmpty
        }, d.id + '_' + Math.random());
      })
    });
  };

  if (isGkAnswersEmpty() === true) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DiagnosticFitEmpty.default, {
      name: "bcEmpty",
      namespace: translateNs
    });
  } else {
    if (!bcEmpty && !pcEmpty && diagnostic.itemsFit.length > 0) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(DiagnosticList, {});
    } else {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: bcEmpty && pcEmpty ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_DiagnosticFitEmpty.default, {
          name: "pcAndBcEmpty",
          namespace: translateNs,
          t: t
        }) : bcEmpty ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_DiagnosticFitEmpty.default, {
          name: "bcEmpty",
          namespace: translateNs,
          t: t
        }) : pcEmpty ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_DiagnosticFitEmpty.default, {
          name: "pcEmpty",
          namespace: translateNs,
          t: t
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {})
      });
    }
  }
};

var _default = /*#__PURE__*/_react.default.memo(Diagnostic);

exports.default = _default;